export default __webpack_public_path__ + "static/media/parkingslot3.41214f8f.png";